module.exports = __webpack_public_path__ + "static/media/nu.f2c773d5.png";